import React from 'react';
import {Link} from "react-router-dom";
import '../App.css';
import amazon from '../images/amazon.png';
import book from '../images/book.png';
import event from '../images/event.png';


function Amazon(props) {
  return (
    <div className="caseify">
      <div><Link to="/" id="back">(back)</Link></div>
      <div> </div>
      <div id="title">Amazon - Shopping and Search Design</div>
      <img src={amazon} alt="Amazon shopping and search ux design cover graphic"/>
        <div id="tablerow">
            <div id="casetitle">About</div>
            <p><i>Add to Cart! Sponsored products!! Same-day delivery!!!</i></p>
            <p>Amazon can be very overwhelming at times, so how do customers navigate the ever expansive product catalog and buy what they need? 
            What are customers considering when they type into the search bar and browse the search results?</p>
            <img id="art2" src="https://i.redd.it/f2y4ftozel871.jpg" alt="5.0 stars 19 reviews vs 4.6 stars 2k reviews"/>
            <br></br>
            <p>My goal as a search designer is to identify a customer’s shopping intent based on implicit and explicit signals (i.e. purchase history, product type, and preferences) 
            to optimize for relevancy. Here is a glimpse into the customer experiences I’ve contributed to.</p>
        </div>

        <div id="tablerow">
            <div id="casetitle">Exact match queries - Books</div>
            <img id="art2" src={book} alt="Designs for exact match book queries"/>
            <p>If you’re shopping for a book, then why not take you to that book’s detail page and expedite the shopping journey? There’s no need to recreate the hassle of wandering through a store to find the exact product you need on Amazon. 
            A book title likely has a direct match to a product, so our solution is to show a navigational shortcut with the search suggestions to reduce the amount of steps a customer takes to get from book title to cart. </p>
        </div>

        <div id="tablerow">
            <div id="casetitle">Seasonal events - Back to school / Off to college</div>
            <img id="art2" src={event} alt="Designs for seasonal events"/>
            <p>Jacket is to winter as pencil is to school as tree is to Christmas. You get what I mean. There’s certain products that trend in searches due to an event like Back to school season from July to September. 
            In collaboration with the marketing team that targets high velocity events, Amazon Search surfaces navigational shortcuts to their marketing campaign, which helps customers shop within an event and refine their shopping journey to specific missions (i.e. school supplies, electronics, backpacks).</p>
        </div>

        <div id="tablerow">
          <div id="casetitle">Design approach</div>
            <p>I strive to earn trust through my designs. Whether that be building a vision with product partners who work back from a problem, using my front-end skills to bridge our designs and code templates with engineers, or polishing the design team's visual storytelling to get leadership excited about our initiatives, I design with cross-functional teams to create meaningful experiences.</p>
            <p>For more work samples, contact me at <a href="mailto:dinhmegann@gmail.com">dinhmegann@gmail.com</a></p>
        </div>
      
      <p>.・。.・゜✭・.・✫・゜・。.</p>


    </div>

  );
}

export default Amazon;

